import { Menu as MantineMenu } from "@mantine/core";

import useStyles from "_styles/atoms/menu";

const Menu = ( {
	children,
	paperClass,
	open,
	paperProps,
	handleClose,
	containerClassName = "",
	...props
} ) => {
	const { classes, cx } = useStyles ( undefined, { name: "styles" } );

	return (
		<MantineMenu
			classNames      = { { dropdown: cx ( paperClass, classes.container ), item: classes.listContainer } }
			id              = "basic-menu"
			onClose         = { handleClose }
			opened          = { open }
			PaperProps      = { paperProps }
			radius          = "lg"
			styles          = { { dropdown: paperProps?.style } }
			transitionProps = { { duration: 200, transition: "fade" } }
			{ ...props }
		>
			<MantineMenu.Dropdown>
				<div className = { `${ containerClassName } ${ classes.contentContainer } ` }>
					{children}
				</div>
			</MantineMenu.Dropdown>

		</MantineMenu>
	);
};

const MenuTarget = ( { children } ) => {
	return (
		<MantineMenu.Target>
			{children}
		</MantineMenu.Target>
	);

};

export default Menu;
export { Menu, MenuTarget };
